goog.provide("shadow.js.shim.module$src$svg$wpp$content$stack_svg$default");
shadow.js.shim.module$src$svg$wpp$content$stack_svg$default = shadow.js.shim.module$src$svg$wpp$content$stack_svg.default;
